<template>
    <v-content>
        <v-row>
            <v-col class="title"> Статистика скрытия офферов </v-col>
        </v-row>
        <v-row>
            <v-col>
                <TimePicker
                    :model.sync="filters.registerDate.from"
                    label="Дата: от"
                    :outlined="true"
                    :dense="true"
                ></TimePicker>
            </v-col>
            <v-col>
                <TimePicker
                    :model.sync="filters.registerDate.to"
                    label="Дата: до"
                    :outlined="true"
                    :dense="true"
                ></TimePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-select
                    v-model="filters.type"
                    :items="type"
                    item-text="name"
                    item-value="id"
                    label="Считать по ..."
                    outlined
                    dense
                    clearable
                ></v-select>
            </v-col>
            <v-col class="title">
                <MultiplySelect
                    :model.sync="filters.utmSources"
                    :options="utmSources"
                    field="utm_source"
                    value="utm_source"
                    placeholder="Utm_source"
                    :dense="true"
                >
                </MultiplySelect>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn @click="getOfferStatistics()" color="primary">Применить</v-btn>
                <v-btn @click="clearFilters()" color="info" style="margin-left: 20px">Очистить</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div class="title">Всего найдено: {{statistics.headers.length ? (statistics.headers.length - 2): 0}} офферов и {{ statistics.items.length}}  utm_sources</div>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    :headers="statistics.headers"
                    :items="statistics.items"
                    :items-per-page="15"
                    fixed-header
                    :loading="isLoading"
                    loading-text="Загрузка..."
                >
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items">
                                <td v-for="(td, index) in item" :class="index === 0? 'sticky' : (index === 1 ? '' : getStyle(td))"  @click="index === 0? sortColumns(item): ''">
                                    {{td}}
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-content>
</template>

<script>
import TimePicker from '@/app/shared/components/form-inputs/TimePicker';
import MultiplySelect from '@/app/shared/components/form-inputs/MultiplySelect';

export default {
    name: "OfferStatistics",
    components: {
        TimePicker,
        MultiplySelect,
    },
    data() {
        return {
            type: [
            {
                id: 0,
                name: 'По постбекам',
            },
            {
                id: 1,
                name: 'По чекерам',
            }],
            rangeItems: [],
            sortBy: {
                'direction': false,
                'field': '',
            },
        };
    },
    created() {
        this.$store.dispatch("GET_UTM_SOURCES_LIST");
        this.getOfferStatistics();
    },
    computed: {
        utmSources: {
            get() {
                return this.$store.getters.UTM_SOURCES;
            },
        },
        filters: {
            get() {
                return this.$store.getters.GET_OFFER_FILTERS;
            },
        },
        statistics: {
            get() {
                return this.$store.getters.STATISTICS;
            },
        },
        isLoading: {
            get() {
                return this.$store.getters.STATISTICS_IS_LOADING;
            }
        },
    },
    methods: {
        getOfferStatistics() {
            const params = {
                filters: JSON.parse(JSON.stringify(this.filters)),
            };

            let diff = new Date().getTimezoneOffset();

            if (params.filters.registerDate.from) {
                let some_date = new Date(params.filters.registerDate.from);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.from = some_date;
            }
            if (params.filters.registerDate.to) {
                let some_date = new Date(params.filters.registerDate.to);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.to = some_date;
            }

            this.$store.commit("SET_STATISTICS", {
                "items": [],
                "headers": [],
            });
            this.$store
                .dispatch("GET_OFFERS_STATISTICS", params)
                .then((data) => {
                    this.$toaster.success("Статистика успешно получена");
                    this.rangeItems = Object.keys(this.statistics.range);
                })
                .catch((error) => {
                    this.$toaster.error("Неизвестная ошибка!");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        clearFilters() {
            this.$store.dispatch('REFRESH_OFFER_FILTERS');
        },
        getStyle(cell) {
            if (cell === 0) {
                return '';
            }
            if (this.rangeItems[0] < cell && cell <= this.rangeItems[1]) {
                return this.statistics.range[this.rangeItems[0]];
            }
            if (this.rangeItems[1] < cell && cell <= this.rangeItems[2]) {
                return this.statistics.range[this.rangeItems[1]];
            }
            if (this.rangeItems[2] < cell && cell <= this.rangeItems[3]) {
                return this.statistics.range[this.rangeItems[2]];
            }
            if (this.rangeItems[3] < cell && cell <= this.rangeItems[4]) {
                return this.statistics.range[this.rangeItems[3]];
            }
            if (this.rangeItems[4] < cell) {
                return this.statistics.range[this.rangeItems[4]];
            }
            return '';
        },
        sortColumns(row) {
            const params = {
                filters: JSON.parse(JSON.stringify(this.filters)),
            };

            let diff = new Date().getTimezoneOffset();

            if (params.filters.registerDate.from) {
                let some_date = new Date(params.filters.registerDate.from);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.from = some_date;
            }
            if (params.filters.registerDate.to) {
                let some_date = new Date(params.filters.registerDate.to);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.to = some_date;
            }

            if (this.sortBy.field === row[0]) {
                this.sortBy.direction = this.sortBy.direction !== true;
            } else {
                this.sortBy.field = row[0];
                this.sortBy.direction = false;
            }

            params.filters.direction = this.sortBy.direction;
            params.filters.field = this.sortBy.field;

            this.$store
                .dispatch("GET_OFFERS_STATISTICS", params)
                .then((data) => {
                    this.$toaster.success("Статистика успешно получена");
                    this.rangeItems = Object.keys(this.statistics.range);
                })
                .catch((error) => {
                    this.$toaster.error("Неизвестная ошибка!");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style>
.sticky {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    background: lightsteelblue !important;
    z-index:9;
}
</style>
